import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDashboardChartInitial } from "api/dashboard";

// Module-scoped in-flight map to dedupe concurrent requests per unique key
const inFlightRequests = new Map(); // key -> Promise

// Single initial fetch for a unique (dashboard_id, chartid)
export const fetchInitialDataThunk = createAsyncThunk(
    "initialData/fetchInitialData",
    async (payload, { getState, rejectWithValue }) => {
        const { dashboard_id, chartid } = payload || {};
        const key = (dashboard_id && chartid) ? `${dashboard_id}:${chartid}` : null;
        if (!key) {
            return rejectWithValue("Invalid dashboard/chart identifiers");
        }
        try {
            // Return the same in-flight promise if a request is already ongoing
            if (inFlightRequests.has(key)) {
                return await inFlightRequests.get(key);
            }
            const promise = getDashboardChartInitial({ dashboard_id, chartid });
            inFlightRequests.set(key, promise);
            const resp = await promise;
            return resp;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error?.message || "Request failed");
        } finally {
            // Ensure cleanup of in-flight promise slot
            if (key) inFlightRequests.delete(key);
        }
    },
    {
        // Prevent dispatching if already cached or already loading
        condition: (payload, { getState }) => {
            const { dashboard_id, chartid } = payload || {};
            const key = (dashboard_id && chartid) ? `${dashboard_id}:${chartid}` : null;
            if (!key) return false;
            const state = getState();
            const slice = state?.InitialDataReducer;
            if (!slice) return true;
            if (slice.loadingByKey?.[key]) return false; // already fetching
            if (slice.byKey?.[key]) return false; // already cached
            return true;
        }
    }
);


